import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../state/store';

export type User = {
  accessToken: string;
  accountId: string;
  locale: string;
};

export const loginSlice = (user: User) =>
  createSlice({
    name: 'login',
    initialState: {
      user,
    },
    reducers: {},
  });

export const getUser = (state: RootState) => state.login.user;
